import React from 'react';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

const { Panel } = Collapse;

class InvoicePicklistReportScreen extends React.PureComponent {
  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'invoice_picklist_report' })}>
        <Collapse defaultActiveKey={['1', '2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

InvoicePicklistReportScreen.propTypes = {
  intl: PropTypes.object,
  match: PropTypes.object
};

InvoicePicklistReportScreen.defaultProps = {
  intl: {},
  match: {}
};

export default injectIntl(InvoicePicklistReportScreen);
